<app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
<div class="flex justify-between my-3">
  <h2>View Users</h2>
  <button *appHasAnyPrivilege="'USER_CREATE'" nz-button nzType="primary" [routerLink]="'add-edit'">
    Add New User
  </button>
</div>
<nz-card>
  <div class="flex flex-col gap-3">
    <div [ngClass]="loading ? 'hidden' : 'block'">
      <nz-collapse>
        <nz-collapse-panel [nzHeader]="'Advanced Search'">
          <!--          <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">-->
          <!--            <div class="flex flex-col xl:flex-row xl:items-center gap-2 xl:gap-0">-->

          <div class="flex flex-col sm:flex-row sm:justify-between md:items-end lg:items-end xl:items-center gap-4">

            <div class="flex flex-col lg:flex-row lg:items-end xl:items-center gap-2 lg:gap-0">


              <div class="flex flex-col lg:flex-row lg:items-end">
<!--                <nz-divider class="hidden 2xl:block" [nzType]="'vertical'"></nz-divider>-->

                <nz-form-item class="flex flex-col xl:flex-row m-0">
                  <nz-form-label class="text-start">Filter by Status</nz-form-label>
                  <nz-select [(ngModel)]="filterStatus" (ngModelChange)="search()" nzPlaceHolder="Select Status"
                             [nzAllowClear]="true">
                    <nz-option [nzValue]="true" nzLabel="Active"></nz-option>
                    <nz-option [nzValue]="false" nzLabel="Inactive"></nz-option>
                  </nz-select>
                </nz-form-item>

                <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>

                <nz-form-item class="flex flex-col xl:flex-row m-0">
                  <nz-form-label class="text-start">Filter by Role</nz-form-label>
                  <nz-select [(ngModel)]="filterRole" (ngModelChange)="search()" nzPlaceHolder="Select Role"
                             [nzAllowClear]="true" >
                    <nz-option *ngFor="let op of rolesOptions" [nzValue]="op._id"
                               nzLabel="{{ op.name | titlecase }}"></nz-option>
                  </nz-select>
                </nz-form-item>

                <nz-divider class="hidden lg:block" [nzType]="'vertical'"></nz-divider>
              </div>

              <nz-form-item class="m-0">
                <nz-input-group nzSearch [nzAddOnAfter]="suffixIconSearchButton">
                  <input type="text" [(ngModel)]="searchText" nz-input placeholder="Search Users" (keyup.enter)="search()" />
                </nz-input-group>
                <ng-template #suffixIconSearchButton>
                  <button nz-button nzType="primary" nzSearch class="bg-[#6B6C6E] border-[#6B6C6E]" (click)="search()">
                    <span nz-icon nzType="search"></span>
                  </button>
                </ng-template>

              </nz-form-item>

            </div>

            <div class="">
              <button nz-button nzBlock class="outline-button" (click)="resetSearch()">
                Reset All
              </button>
            </div>

          </div>
        </nz-collapse-panel>
      </nz-collapse>
    </div>

    <div [ngClass]="loading ? 'hidden' : 'block'" class="table-card">
      <div class="table-obj">
        <nz-table #basicTable [nzData]="usersData" [nzShowSizeChanger]="pageSize.length > 5"
                  [nzPageSizeOptions]="pageSize.pageSizeOptions" [nzPageSize]="pageSize.pageSize"
                  [nzPageIndex]="pageSize.pageIndex" [nzFrontPagination]="false" [nzTotal]="pageSize.length"
                  (nzQueryParams)="onTableParamsChange($event)" [nzScroll]="{ x: 'auto', y: '550px' }" nzTableLayout="fixed"
                  nzOuterBordered class="table-wSpace-nowrap">
          <thead>
          <tr>
            <th style="min-width: 100px;">Staff No.</th>
            <th >User Name</th>
            <th >Role</th>
            <th >Mobile</th>
            <th >Email</th>
            <th >Department</th>
            <th >Status</th>
            <th >Last Login Date</th>
            <th >
              <div class="flex">
                <span>Created Date</span>
                <span *ngIf="sortOrder === -1" nz-icon nzType="up" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
                <span *ngIf="sortOrder === 1" nz-icon nzType="down" nzTheme="outline"
                      class="ml-2 mr-1 p-1 w-2 h-2 cursor-pointer" (click)="sort()">
                  </span>
              </div>
            </th>
            <th *ngIf="hasAccessToPerformAction()">Actions</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let data of basicTable.data; let rowNum = index" class="align-baseline">
            <td style="min-width: 150px;">{{ data.staffNumber }}</td>
            <td style="min-width: 150px;">
              <div class="flex items-center gap-3">
                <div>
                  <nz-avatar style="width: 2rem; height: 2rem" nzIcon="user" [nzSrc]="data.imageUrl"></nz-avatar>
                </div>
                <div>
                    <span>{{
                      data.firstname + " " + data.lastname | titlecase
                      }}</span>
                </div>
              </div>
            </td>
            <td style="min-width: 150px;">{{ data.role?.name | titlecase }}</td>
            <td style="min-width: 150px;" class="clickable-mail-phone_no"><a class="clickable-phone_no" href="tel:{{ data.mobile }}">{{ data.mobile }}</a></td>
            <td style="min-width: 150px;" class="clickable-mail-phone_no"><a class="clickable-mail-phone_no font-medium" href="mailto:{{ data.email }}">{{ data.email }}</a></td>
            <td style="min-width: 150px;">
              <div *ngIf="data.department.length > 1">

                   <div *ngIf="haveRowNumCheck(rowNum)">
                     <div *ngFor="let dep of data.department; let i = index">
                       <div>
                         <span>{{dep.company ? dep.department.name + " - " + dep.company.name : dep.department.name}}</span>
                       </div>
                     </div>
                     <div>
                       <span class="cursor-pointer text-primary see-more-click" (click)="moreDepCollapse(rowNum, 'hide_more')">hide more</span>
                     </div>
                   </div>

                   <div *ngIf="!haveRowNumCheck(rowNum)">
                     <div *ngFor="let dep of data.department; let i = index">
                       <div *ngIf="i === 0">
                        <span>{{dep.company ? dep.department.name + " - " + dep.company.name : dep.department.name}}
                          <span class="cursor-pointer text-primary see-more-click" (click)="moreDepCollapse(rowNum, 'more')">and {{data.department.length - 1}} more</span>
                        </span>
                       </div>
                     </div>
                   </div>

              </div>
              <div *ngIf="data.department.length === 1">
                <div *ngFor="let dep of data.department; let i = index">
                  <span>{{dep.company ? dep.department.name + " - " + dep.company.name : dep.department.name}}</span>
                </div>
              </div>
            </td>
            <td style="min-width: 150px;">
              <nz-tag *ngIf="data.active" [nzColor]="'#3ab200'" class="rounded-full">Active</nz-tag>
              <nz-tag *ngIf="!data.active" [nzColor]="'#ff4d4f'" class="rounded-full">Inactive</nz-tag>
            </td>
            <td style="min-width: 150px;">
              {{
              data.lastLoginDate
                ? (data.lastLoginDate | date: "dd-MM-y")
                : "-"
              }}
            </td>
            <td style="min-width: 150px;">{{ data.createdAt | date: "dd-MM-y" }}</td>
            <td style="min-width: 150px;" *ngIf="hasAccessToPerformAction()">
              <div class="flex gap-1">
<!--                <button *ngIf="checkPermissionsWithUserActiveStatus(data, 'USER_UPDATE')" class="outline-button mr-3" nz-button nzType="default"-->
<!--                        [routerLink]="'add-edit/' + data._id">-->
<!--                  Edit-->
<!--                </button>-->
                <button *appHasAnyPrivilege="'USER_UPDATE'" [disabled]="!data.active" [class.outline-button]="data.active" class="mr-3" nz-button nzType="default"
                        [routerLink]="'add-edit/' + data._id">
                  Edit
                </button>
                <button *ngIf="hasAccessToPerformAction()" class="outline-button more-dropdown" nz-button nz-dropdown
                        [nzDropdownMenu]="menu"
                        nzPlacement="bottomCenter">
                  <span nz-icon nzType="more" nzTheme="outline"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li *appHasAnyPrivilege="'USER_CHANGE_STATUS'" nz-menu-item nz-popconfirm nz-button nzPopconfirmTitle="{{
                          data.active
                            ? 'Are you sure you want to deactivate the account ' +
                              data.email +
                              '?'
                            : 'Are you sure you want to activate the account ' +
                              data.email +
                              '?'
                        }}" (nzOnConfirm)="changeStatus(data._id, data.active)">
                      {{ data.active ? "Deactivate" : "Activate" }}
                    </li>
                    <li *ngIf="checkPermissionsWithUserActiveStatus(data, 'USER_RESET_PASSWORD')" nz-menu-item nz-popconfirm nz-button
                        nzPopconfirmTitle="Are you sure you want to change the password for {{data.email}}?"
                        (nzOnConfirm)="resetPwd(data._id)">
                      Reset Password
                    </li>
                    <li *ngIf="checkPermissionsWithUserActiveStatus(data, 'USER_DELETE')" nz-menu-item nz-popconfirm nz-button nzDanger
                        nzPopconfirmTitle="Are you sure you want to delete account {{
                          data.email
                        }}?" (nzOnConfirm)="softDeleteConfirm(data._id)">
                      Delete
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </div>
            </td>
          </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
    <div [ngClass]="loading ? 'block' : 'hidden'">
      <app-table-skeleton-template [columnData]="skeletonTableColumns"></app-table-skeleton-template>
    </div>
  </div>
</nz-card>
